// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 诊股结果 GET /stock-diagnose/result */
export async function stockDiagnoseResultUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockDiagnoseResultUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockDiagnoseResultResp>('/stock-diagnose/result', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 提交诊股 POST /stock-diagnose/submit */
export async function stockDiagnoseSubmitUsingPOST(
  body: API.StockDiagnoseSubmitReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockDiagnoseSubmitResp>('/stock-diagnose/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
